import React, { useMemo } from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import classNames from 'classnames';

const ChooseContent = ({ data }: any) => {
  const getTitle = useMemo(() => {
    return <h2 className={styles.title}>{data.contentInfo['section-why'].title}</h2>;
  }, []);

  const getImage = useMemo(() => {
    return (
      <div className={styles.img}>
        <Image
          src={data.contentInfo['section-why'].imgPath}
          alt={'erasa'}
          width={100}
          height={100}
          layout="responsive"
          priority
          fetchPriority="high"
          objectFit="cover"
        />
      </div>
    );
  }, []);

  const getContent = () => {
    return (
      <div className={styles.content}>
        <h2 className={styles.titleMain}>{data.contentInfo['section-who'].title}</h2>
        <div className={styles.desc}>{data.contentInfo['section-who'].desc}</div>

        <div className={styles.MobileContentItem}>
          <div>{getTitle}</div>
        </div>
        <div className={styles.mainContent}>
          {getImage}
          <div className={styles.contentList}>
            <div className={styles.pcContentItem}>
              <div>{getTitle}</div>
            </div>

            {data.contentInfo['section-why'].cards.map((item: any, index: any) => (
              <div className={styles.contentItem} key={index}>
                <div className={classNames(styles.contentItemTitle)}>
                  <Image src={item.imgPath} alt={item.title} width={20} height={20} loading="lazy" />
                  <h3 className={styles.subTitle}>{item.title}</h3>
                </div>
                <p className={styles.subDesc}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return <>{getContent()}</>;
};

export default ChooseContent;
